import { insuranceTypes } from '@/src/constants/itinerary/insurance'
import { Flight, VasAncillary } from '@/src/types/itinerary'

export const extractFlightInfo = (flights: Flight[], delimiter = ',') => {
    const airlines: string[] = []
    const airlineNames: string[] = []
    const flightNumbers: string[] = []
    const flightIds: string[] = []
    const flightRouteStops: string[] = []
    let cabinType = ''

    flights.forEach(flight => {
        const { segments = [] } = flight || {}
        const stops = segments.length - 1
        const stopInfo = `${stops || 'non'} stop`
        const airlineCodes: string[] = []
        segments?.forEach(segment => {
            const { airline = '', airlineName = '', flightNumber = '', arrivalAirport } = segment || {}
            if (airline) airlines.push(airline.toLowerCase())
            if (airlineName) airlineNames.push(airlineName.toLowerCase())
            if (flightNumber) flightNumbers.push(flightNumber.toLowerCase())
            if (flightNumber) flightIds.push(`${airline} - ${flightNumber}`.toLowerCase())
            cabinType = segment?.cabinType?.toLowerCase() || ''
            airlineCodes.push(arrivalAirport)
        })
        if (stops) {
            flightRouteStops.push(`${stopInfo} ( ${airlineCodes.join(' , ')} )`.toLowerCase())
        } else {
            flightRouteStops.push(stopInfo)
        }
    })

    return {
        airline: airlines.join(delimiter) || 'N/A',
        airlineName: airlineNames.join(delimiter) || 'N/A',
        flightNumber: flightNumbers.join(delimiter) || 'N/A',
        flightIds: flightIds.join(delimiter) || '',
        flightRouteStops: flightRouteStops.join('<>') || '',
        cabinType
    }
}

export const checkInsuranceEligibility = (insuranceTypesList: string[], insuranceList: VasAncillary[]) => {
    return insuranceList?.some(
        insuranceItem => insuranceTypesList.includes(insuranceItem.vasType) && insuranceItem.eligible
    )
        ? 'Yes'
        : 'No'
}

export const extractInsuranceProviders = (insuranceList: VasAncillary[]) => {
    const insuranceProvider = new Set<string>()

    if (Array.isArray(insuranceList)) {
        insuranceList.forEach(vas => {
            const { vasType, vasProvider } = vas || {}
            if (insuranceTypes.includes(vasType) && vasProvider) {
                insuranceProvider.add(vasProvider)
            }
        })
    }

    return Array.from(insuranceProvider).join(',') || 'N/A'
}
